var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckIc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 58,
    height: 60,
    viewBox: "0 0 58 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Fill_1_Copy_2",
    "data-name": "Fill 1 Copy 2",
    d: "M29,60a28.045,28.045,0,0,1-11.3-2.355,28.822,28.822,0,0,1-9.217-6.424,29.931,29.931,0,0,1-6.21-9.535,31.142,31.142,0,0,1,0-23.373,29.929,29.929,0,0,1,6.21-9.535A28.821,28.821,0,0,1,17.7,2.354a28.28,28.28,0,0,1,22.594,0,28.82,28.82,0,0,1,9.217,6.424,29.928,29.928,0,0,1,6.21,9.535,31.144,31.144,0,0,1,0,23.373,29.93,29.93,0,0,1-6.21,9.535A28.821,28.821,0,0,1,40.3,57.646,28.046,28.046,0,0,1,29,60ZM15.441,27.258a2.884,2.884,0,0,0-2.022,4.913l9.009,8.975A2.686,2.686,0,0,0,24.415,42a2.8,2.8,0,0,0,1.987-.854L44.635,22.914a2.985,2.985,0,0,0,0-4.059,2.818,2.818,0,0,0-4.044,0L24.415,35.093l-6.953-6.979A2.837,2.837,0,0,0,15.441,27.258Z",
    fill: "#02aca0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIc);
export default __webpack_public_path__ + "static/media/check-ic.1f4a1c6758bf7e6d76ad99bc737a2cc1.svg";
export { ForwardRef as ReactComponent };